import { useState, useCallback } from "react";

export interface OpenCloseHookProps {
  isOpen: boolean;
  close: () => void;
  open: (param?: any) => void;
}

export function useOpenClose(onCloseExtra?: () => void, onOpenExtra?: (param: any) => void) {
  const [isOpen, setIsOpen] = useState(false);
  const open = useCallback((param='') => {
    setIsOpen(true);
    onOpenExtra && onOpenExtra(param)
  }, []);
  const close = useCallback(() => {
    setIsOpen(false);
    onCloseExtra && onCloseExtra()
  }, []);
  return { isOpen, open, close } as OpenCloseHookProps;
}
